// extracted by mini-css-extract-plugin
module.exports = {"text":"UpdateExtension_text__36UQr","info":"UpdateExtension_info__2idxV"};